export var vehicleMixin = {
        data : () => {
            return {
                vehicleQuery: {placa: '', marca: '', modelo: '', proprietario: '', page: 1, todos: null},
                selectedHeaderOptions : [{
                    text:'PLACA',
                    value:'PLACA'
                },
                {
                    text: 'MARCA',
                    value: 'MARCA'
                },
                {
                    text: 'ANO',
                    value: 'ANO'
                },
                {
                    text: 'COR',
                    value: 'COR'
                },
                {
                    text: 'PROPRIETARIO',
                    value: 'empresa.NOME'
                },
                {
                    text: 'Nº CHASSI',
                    value: 'CHASSI'
                },
                {
                    text: 'Ações',
                    value: "controls",
                    align: 'right'
                }],
            }
    }
}

